import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';

@Injectable(
  	{ providedIn: 'root' }
)

export class JwtService {

	constructor(private jwtHelper: JwtHelperService) {}

	public saveToken(token: string): void {
		localStorage.setItem('jwt', token);
	}

	public getToken(): string | null {
		return localStorage.getItem('jwt');
	}

	public clearToken(): void {
		localStorage.removeItem('jwt');
	}

	public isTokenExpired(): boolean {
		const token = this.getToken();
		return token ? this.jwtHelper.isTokenExpired(token) : true;
	}

	public isLoggedIn(): boolean {
		return !this.isTokenExpired();
	}
  
}